import { Component, ContentChild, Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { SbIcons } from '@ngx-seatback/icons';
import { Permission } from '../../services/api/permission';

export interface SbDropdown {
  name?: string;
  width?: number;
  type?: string;
  translate?: boolean;
  items: SbDropdownItemWithHover[];
}

export interface SbDropdownItem {
  name?: string;
  translate?: boolean;
  action?: string;
  link?: string;
  icon?: SbIcons;
  image?: string;
  selected?: boolean;
  subDropdown?: SbDropdown;
  permissions?: Permission[];
  separatorAfter?: boolean;
  separatorBefore?: boolean;
}

interface SbDropdownItemWithHover extends SbDropdownItem {
  hover?: boolean;
}

@Directive({
  selector: '[dropdown-header]',
  standalone: false,
})
export class SbLevelDropdownHeaderDirective {}

@Directive({
  selector: '[dropdown-footer]',
  standalone: false,
})
export class SbLevelDropdownFooterDirective {}

@Component({
  selector: 'sb-level-dropdown',
  templateUrl: './sb-level-dropdown.component.html',
  styleUrls: ['./sb-level-dropdown.component.scss'],
  standalone: false,
})
export class SbLevelDropdownComponent implements OnInit {
  constructor(private eRef: ElementRef) {}

  @ContentChild(SbLevelDropdownHeaderDirective, { static: false }) contentHeader?: SbLevelDropdownHeaderDirective;
  @ContentChild(SbLevelDropdownFooterDirective, { static: false }) contentFooter?: SbLevelDropdownHeaderDirective;
  @Input() dropdown: SbDropdown;
  _placement: string;
  @Output() clickedAction: EventEmitter<SbDropdownItem> = new EventEmitter<SbDropdownItem>();
  selectedSubdropdown: SbDropdown;
  selectedDropdown: SbDropdown;
  dropdownOpen: boolean;
  placementStyle: string;

  @Input() set placement(val: string) {
    this._placement = val;
    this.resolvePlacement();
  }

  get placement(): string {
    return this._placement;
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
      this.selectedSubdropdown = null;
    }
  }

  ngOnInit(): void {}

  selectSubdropdown($event, dropdown) {
    $event.stopPropagation();
    this.selectedSubdropdown = dropdown;
  }

  openDropdown() {
    this.selectedSubdropdown = null;
    this.dropdownOpen = !this.dropdownOpen;
  }

  runAction(item: SbDropdownItem) {
    this.clickedAction.emit(item);
    this.openDropdown();
  }

  resolvePlacement() {
    switch (true) {
      case this.placement === 'right': {
        this.placementStyle = 'right: 0; left: auto;top: 100%';
        break;
      }
    }
  }
}
